export const voluntaryDelistValidationMap: Record<string, Record<string, string | ((error: any) => string)>> = {
    reason: {
        maxlength: (error: any) => `Reason cannot exceed ${error.requiredLength} characters.`,
    },
};
